import styles from "../../../../styles/finder/finder.module.scss"
import { useEffect, useState } from "react"
import CheckBox from "../../checkbox/checkbox"
import { STEPS, useUserStore, useWizardStore } from "../store/finder_store"
import skColors from "../../../../styles/skColors"
import StyledText from "../../../typography/typography-component"
import Image from "next/image"
import { useTranslations } from "next-intl"

const Step3a = ({ onDisabledChange }: { onDisabledChange: (value: boolean) => void }) => {
  const t = useTranslations("index.finder")
  const [standaloneSelectOptions, setStandaloneSelectOptions] = useState([])
  const [selectOtherCheckbox, setSelectOtherCheckbox] = useState(false)
  const [selectedHealthInsurance, setSelectedHealthInsurance] = useState<string>()
  const { firstName, lastName, address, mail, confirmDataUsage, confirmSkinuvitaInterest, nominatimResponse } =
    useUserStore()
  const { step, setStep } = useWizardStore()
  const removeItem = (value) => {
    setStandaloneSelectOptions((prevItems) => prevItems.filter((item) => item !== value))
  }

  // function checkOption(option: string) {
  //   standaloneSelectOptions.includes(option)
  //     ? removeItem(option)
  //     : setStandaloneSelectOptions((prevState) => {
  //         return [...prevState, option]
  //       })
  // }

  useEffect(() => {
    onDisabledChange(
      !(
        firstName &&
        lastName &&
        address?.city &&
        address?.houseNumber &&
        address?.street &&
        mail &&
        confirmDataUsage &&
        confirmSkinuvitaInterest
      )
    )
  }, [onDisabledChange, firstName, lastName, address, mail, confirmDataUsage, confirmSkinuvitaInterest])

  return (
    <div className={styles.step3Content}>
      <StyledText variant="h3" color={skColors.turquoise[600]}>
        {t("step1.title")}
      </StyledText>

      <div className={styles.descriptionWrapper}>
        <StyledText as="p" variant="pRegular">
          {t("step3a.text1")} <br />
          <StyledText as="span" variant="h6" color={skColors.darkgreen[600]} style={{ fontSize: "inherit" }}>
            {" "}
            {t("step3a.highlight")}
          </StyledText>
          . {t("step3a.text2")}
        </StyledText>
      </div>

      <div className={styles.mailImageWrapper}>
        <Image
          src={"/svg/mail_image.svg"}
          alt={"mail was sent"}
          width={328}
          height={217}
          className={styles.mailImage}
        />
      </div>
    </div>
  )
}

export default Step3a
